import React from "react";

type JoinBirthdayType = { authData: any; setAuthData: Function };

const JoinBirthday = ({ authData, setAuthData }: JoinBirthdayType) => {
  const handleChangeSelect = (e: any) => {
    setAuthData((previousValue: any) => ({ ...previousValue, birthYear: e.target.value }));
  };
  const handleChangeSex = (s: string) => {
    setAuthData((previousValue: any) => ({ ...previousValue, sex: s }));
  };

  const thisYear = new Date().getFullYear();
  const startYear = 1930;
  return (
    <div className="cmap1010-input">
      <div className="title">출생연도</div>
      <div className="input-wrap">
        <div className="input">
          <div className="select-box">
            <select name="birthYear" value={authData.birthYear} onChange={handleChangeSelect}>
              {[...Array(thisYear - 16 - startYear)].map((u, i) => (
                <option key={i + startYear} value={i + startYear}>
                  {i + startYear}
                </option>
              ))}
            </select>
            <span>년</span>
          </div>
        </div>
        <ul className="check">
          <li className={authData.sex === "M" ? "active" : ""} onClick={() => handleChangeSex("M")}>
            남
          </li>
          <li className={authData.sex === "F" ? "active" : ""} onClick={() => handleChangeSex("F")}>
            여
          </li>
        </ul>
      </div>
    </div>
  );
};

export default JoinBirthday;
